import { render, staticRenderFns } from "./toPage.vue?vue&type=template&id=bc37de08&scoped=true&"
import script from "./toPage.vue?vue&type=script&lang=js&"
export * from "./toPage.vue?vue&type=script&lang=js&"
import style0 from "./toPage.vue?vue&type=style&index=0&id=bc37de08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc37de08",
  null
  
)

export default component.exports